import React from 'react'
import Input from '../../root/components/common/input'
import IconButton from '@material-ui/core/IconButton'
import Clear from '@material-ui/icons/Clear'
import { makeStyles } from '@material-ui/core'

export default function HotSwapDashboardSearch(props) {
    const { filters, onSearch, locale } = props

    const classes = useStyles()

    return (
        <Input
            value={filters.search}
            label={locale.common.search}
            type="text"
            setValue={onSearch}
            debounce={600}
            endIcon={() =>
                filters.search ? (
                    <IconButton
                        size="small"
                        onClick={() => onSearch('')}
                        classes={{ root: classes.searchClearIcon }}
                    >
                        <Clear />
                    </IconButton>
                ) : null
            }
        />
    )
}

const useStyles = makeStyles(() => ({
    searchClearIcon: {
        padding: 0,
        position: 'absolute',
        right: 8
    }
}))
